import { getWindowSessionReplayURL } from '@whitelabel/helpers/utils';
import { IBWClaimsPortalMetrics } from '@whitelabel/xcover-shared/helpers/types';
import { IBWDocUploaderEvent, IBWDocUploaderMetrics, IBWIdentify } from './types';

export const bwClaimDetailsSummaryTracking = ({
  claimReference,
  partnerID,
  partnerName,
  subsidiaryID,
  subsidiaryName,
}: IBWClaimsPortalMetrics): void => {
  if (window.isHeadless || !window.bwtag) return;

  window.bwtag('record', 'claim_summary', {
    claimReference,
    claim_cla: claimReference,
    partner: partnerName,
    partnerID,
    partnerName,
    subsidiaryID,
    subsidiaryName,
    bwSession: getWindowSessionReplayURL() ?? 'BW Not Ready',
  });
};

export const bwIdentify = ({ id, email, firstName, lastName }: IBWIdentify): void => {
  if (window.isHeadless || !window.bwtag) return;

  window.bwtag('identify', id, {
    email,
    firstName,
    lastName,
  });
};

export const bwDocUploaderTrack = <T extends IBWDocUploaderEvent>(eventName: T, metrics: IBWDocUploaderMetrics<T>) => {
  if (window.isHeadless || !window.bwtag) return;

  window.bwtag('record', eventName, {
    ...metrics,
    ins: metrics.bookingID,
    claim_cla: metrics.claimReference,
  });
};

export const bwDocReqSectionExampleLinkTracking = (
  metrics: IBWClaimsPortalMetrics & {
    variant?: string | null;
    url: string;
  },
) => {
  if (window.isHeadless || !window.bwtag) return;

  window.bwtag('record', 'doc_req_section_example_link_click', {
    ...metrics,
    ins: metrics.bookingID,
    claim_cla: metrics.claimReference,
  });
};
